module.exports = __webpack_public_path__ + "img/knowledge-base-bg-light.043912ea.png";